module.exports = __webpack_public_path__ + "static/img/financial.667ae6b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/financial.png
// module id = pL6d
// module chunks = 0